module.exports = __webpack_public_path__ + "static/media/route.a57a1a54.svg";